var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKrb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.865 8.2722C8.99888 8.24913 9.117 8.19907 9.2205 8.12313C9.324 8.0472 9.42188 7.91895 9.51356 7.74345L11.5526 3.81326C11.6325 3.68163 11.7304 3.57701 11.8429 3.49488C11.9585 3.41493 12.0961 3.37304 12.2366 3.37507H13.5298L10.9907 7.9977C10.8782 8.18782 10.7505 8.34251 10.6082 8.46232C10.466 8.58055 10.3039 8.67255 10.1295 8.73401C10.4017 8.80432 10.6296 8.91851 10.8158 9.07882C10.9991 9.23632 11.1741 9.45907 11.3366 9.74538L13.7812 14.6251H12.3581C12.0707 14.6251 11.8395 14.4704 11.6651 14.1638L9.6615 10.0289C9.558 9.84438 9.4455 9.71332 9.324 9.63401C9.20306 9.55526 9.04894 9.50857 8.86556 9.49676V11.5949H7.74675V9.48776H6.92438V14.6251H5.34375V3.37507H6.92438V8.2902H7.74675V5.85907H8.86556L8.865 8.2722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrb);
export default __webpack_public_path__ + "static/media/krb.85570c1b35f01db7fa1d8b2d2ef4786d.svg";
export { ForwardRef as ReactComponent };